import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {VendorPixelSchema} from './analytics/vendor-pixel'

export const PayloadSchema = z.lazy(() =>
  z.object({
    contentfulRawJsonResponse: safeOptional(z.looseObject({})),
    userLoggedIn: z.boolean().optional(),
    octocaptchaHost: z.string().optional(),
    hasNtExperiences: z.boolean().optional(),
    vendorPixels: safeOptional(z.array(VendorPixelSchema)),
  }),
)

export type Payload = z.infer<typeof PayloadSchema>

export function toPayload(payload: unknown): Payload {
  return PayloadSchema.parse(payload)
}

export function isPayload(payload: unknown): payload is Payload {
  return PayloadSchema.safeParse(payload).success
}
